import { api } from "../../../lib/api";
import { LoginFormData, AuthResponse, AdminUser } from "./auth.types";

class AuthService {
  /**
   * Admin Login
   * @param {LoginFormData} payload
   * @returns {Promise<AuthResponse>}
   */
  async login(payload) {
    try {
      const response = await api.post("auth/admin/login", payload);

      if (response.data.status && response.data.data) {
        const { token, user } = response.data.data;

        // Store token in localStorage
        localStorage.setItem("adminToken", token);

        // Store user data in localStorage
        const adminUser = new AdminUser(
          user.id,
          user.username,
          user.email,
          user.phone_number,
          user.role,
          user.is_verified,
          user.is_active
        );
        localStorage.setItem("adminUser", JSON.stringify(adminUser));

        return new AuthResponse(true, { token, user: adminUser });
      }

      return new AuthResponse(false, { error: "Login failed" });
    } catch (error) {
      const message =
        error.response?.data?.data?.error ||
        "Failed to login. Please try again later.";

      return new AuthResponse(false, { error: message });
    }
  }

  /**
   * Logout - Clear stored auth data
   */
  logout() {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
  }

  /**
   * Get current logged-in admin user
   * @returns {AdminUser | null}
   */
  getCurrentUser() {
    const userStr = localStorage.getItem("adminUser");
    if (userStr) {
      try {
        const userData = JSON.parse(userStr);
        return new AdminUser(
          userData.id,
          userData.username,
          userData.email,
          userData.phone_number,
          userData.role,
          userData.is_verified,
          userData.is_active
        );
      } catch {
        return null;
      }
    }
    return null;
  }

  /**
   * Get stored auth token
   * @returns {string | null}
   */
  getToken() {
    return localStorage.getItem("adminToken");
  }

  /**
   * Check if user is authenticated
   * @returns {boolean}
   */
  isAuthenticated() {
    return !!this.getToken();
  }
}

export const authService = new AuthService();